import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth-service';

const CATEGORY_DOMAIN = 3102;

@Injectable({
  providedIn: 'root',
})
export class CategoryFileMgt {
  private httpClient = inject(HttpClient);
  private API = environment.fileMgt;
  private authService = inject(AuthService);
  private sanitizer = inject(DomSanitizer);

  uploadImage(file: File) {
    const token = this.authService.getAccessToken();
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<{ fid: string }>(`${this.API}/domains/${CATEGORY_DOMAIN}/upload`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getImage(imageFid: string) {
    const token = this.authService.getAccessToken();

    return this.httpClient.get(`${this.API}/files/${imageFid}/download`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getFileMetadata(fid: string) {
    const token = this.authService.getAccessToken();

    return this.httpClient.get<{
      id: number;
      fid: string;
      extension: string;
      lastVersion: number;
      createdOn: string;
    }>(`${this.API}/files/${fid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getImageUrl(imageFid: string) {
    return this.getImage(imageFid).pipe(
      map((blob: Blob) => {
        return {
          url: this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob)),
          isImage: blob.type.startsWith('image/'),
          type: blob.type,
        };
      }),
    );
  }
}
